import { likeDiary, removeLikeDiary } from '../../../../api/diary';
import { handleError } from '../../../../utils/common';
import {
  hear_filled_brand_30x30,
  heart_outline_white_30x30,
} from '../../../../utils/common/variables';
import { CommunityGtm } from '../../../../utils/gtm/community/communityGtm';
import { useAlertModal } from '../../../../utils/hook/hook';
import useMeQuery from '../../../../utils/hook/react-query/user/useMeQuery';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../../../../utils/hook/usePathnameMethod';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsLike = ({
  onSuccessToggleLike,
}: {
  onSuccessToggleLike: (diaryId: number) => void;
}) => {
  const { diary } = useDiaryShortsContext();
  const { me } = useMeQuery();
  const history = useHistoryMethod();
  const { openAlertModal } = useAlertModal();
  const { pathname, search } = usePathnameMethod();

  const handleToggleLikeDiary = async () => {
    if (!me) {
      return history.pushToLogin({ redirectURI: `${pathname}${search}` });
    }

    const communityGtm = new CommunityGtm();
    communityGtm.click_like({
      post_type: 'cook_diary',
      post_id: diary.id.toString(),
    });

    const toggleLikeMutation = diary.isLiked ? removeLikeDiary : likeDiary;

    await toggleLikeMutation(diary.id)
      .then(() => {
        onSuccessToggleLike(diary.id);
      })
      .catch((e) => handleError(openAlertModal, e, '집밥일기 좋아요'));
  };

  return (
    <button
      onClick={handleToggleLikeDiary}
      className="flex-center h-48px w-48px shrink-0"
      type="button"
    >
      <div className="flex items-center">
        <img
          src={
            diary.isLiked ? hear_filled_brand_30x30 : heart_outline_white_30x30
          }
          alt="좋아요"
        />
        <p className="text-12px text-white">{diary.likeCount}</p>
      </div>
    </button>
  );
};

export default _DiaryShortsLike;
